import superagent from 'superagent';
import webservice from './webservice';
import getCookie from './getCookie';

export default async function GetRegimenFiscalKit() {
  let response = {};

  await superagent
    .get(`${webservice}/GetRegimenFiscalKit?usuarioOK=${getCookie('usuarioOk')}`)
    .set(('Content-Type': 'application/json'))
    .auth(getCookie('TMBcartToken'), { type: 'bearer' })
    .then((res) => {
      response = res.body.GetRegimenFiscalKitResult;
    })
    .catch((err) => {
      console.log(err);
      const resp = {
        error: err,
        typeMessage: 'error',
        message: 'Error',
      };
      response = resp;
    });

  return response;
}
